import Swal from 'sweetalert2';

const DEFAULT_SWAL = {
  icon: 'error',
  html: 'Revisa el formulario: hay datos que no cumplen la validación.',
  timer: 2000,
  showConfirmButton: false,
};

/**
 * Shows the standard validation toast after Vuelidate reports errors.
 * 
 * @param {object} vm - Vue instance (kept for API compatibility; only $nextTick may be used)
 * @param {object} [options]
 * @param {object} [options.swal] - Merged into Swal.fire (html, timer, icon, etc.)
 */
export function notifyValidationFailedAndFocusFirstInvalid(vm, options = {}) {
  const { swal: swalOverrides = {} } = options;

  vm.$nextTick(() => {
    Swal.fire({
      ...DEFAULT_SWAL,
      ...swalOverrides,
    });
  });
}
